import * as React from 'react';

export const QuestionContext = React.createContext(null);
